// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Command$SmartcutsMacros = require("./Command.bs.js");
var URLUtils$SmartcutsMacros = require("../../bs-utils/src/URLUtils.bs.js");
var ListUtils$SmartcutsMacros = require("../../bs-utils/src/ListUtils.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var PromisedValue$SmartcutsMacros = require("./PromisedValue.bs.js");
var GoogleSheetHelpers$SmartcutsMacros = require("./GoogleSheetHelpers.bs.js");
var GenericCommandWithContextGlobal$SmartcutsMacros = require("./GenericCommandWithContextGlobal.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("./InterfaceBtwnRecordingAndPlayback.bs.js");

function local_encode(v) {
  return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextLocal.t_encode, v);
}

function local_decode(v) {
  return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextLocal.t_decode, v);
}

var t_encode = GenericCommandWithContextGlobal$SmartcutsMacros.t_encode;

var t_decode = GenericCommandWithContextGlobal$SmartcutsMacros.t_decode;

var Entry = {
  t_encode: t_encode,
  t_decode: t_decode
};

function t_encode$1(encoder_command, encoder_contextGlobal, v) {
  return Decco.listToJson((function (param) {
                return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(encoder_command, encoder_contextGlobal, param);
              }), v);
}

function t_decode$1(decoder_command, decoder_contextGlobal, v) {
  return Decco.listFromJson((function (param) {
                return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(decoder_command, decoder_contextGlobal, param);
              }), v);
}

var GlobalForGeneric = {
  Entry: Entry,
  t_encode: t_encode$1,
  t_decode: t_decode$1
};

function t_encode$2(v) {
  return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextGlobalForRecording.t_encode, v);
}

function t_decode$2(v) {
  return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextGlobalForRecording.t_decode, v);
}

function insertAfterId(id, offset, commandsWithContextGlobal, commandLog) {
  var commandLogArray = $$Array.of_list(commandLog);
  var arg = Belt_Array.getIndexBy(commandLogArray, (function (cmdWithContext) {
          return cmdWithContext.id === id;
        }));
  var index = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected command log entry with id=" + String(id));
  return $$Array.to_list($$Array.concat({
                  hd: Belt_Array.slice(commandLogArray, 0, (index + 1 | 0) + offset | 0),
                  tl: {
                    hd: $$Array.of_list(commandsWithContextGlobal),
                    tl: {
                      hd: Belt_Array.sliceToEnd(commandLogArray, (index + 1 | 0) + offset | 0),
                      tl: /* [] */0
                    }
                  }
                }));
}

function extractOrigins(commandLog) {
  return ArrayUtils$SmartcutsMacros.unique(ArrayUtils$SmartcutsMacros.filterMap((function (param) {
                    var url = param.contextGlobal.url;
                    if (url.TAG === /* Resolved */0) {
                      return Belt_Option.map(URLUtils$SmartcutsMacros.$$URL.fromString(url._0), (function (urlRecord) {
                                    return urlRecord.origin;
                                  }));
                    }
                    
                  }), Belt_Array.keep($$Array.of_list(commandLog), (function (param) {
                        var url = param.contextGlobal.url;
                        if (url.TAG === /* Resolved */0) {
                          return url._0 !== "";
                        } else {
                          return false;
                        }
                      }))));
}

function toPrintable(commandLog) {
  return $$Array.of_list(List.map(Command$SmartcutsMacros.CommandWithContextGlobalForRecording.t_encode, commandLog));
}

function toPrintableCommands(commandLog) {
  return $$Array.of_list(List.map((function (param) {
                    return Command$SmartcutsMacros.recordingCommand_encode(param.command);
                  }), commandLog));
}

function getFirstURL(log) {
  if (!log) {
    return Util$SmartcutsMacros.logAndRaiseJsError("log must be non-empty");
  }
  var match = log.hd.command;
  if (typeof match === "number" || match.TAG !== /* NewWindowWithUrlCommand */1) {
    return Util$SmartcutsMacros.logAndRaiseJsError("First command of command log must be NewWindowWithUrlCommand(_, _)");
  } else {
    return match._0.url;
  }
}

function checkIfPromisedTabRefMatchesExistingTabInCommandLog(promisedTabRef, commandLog) {
  if (promisedTabRef.TAG === /* Resolved */0) {
    return Belt_List.reduce(commandLog, /* DoesNotMatchAnyTabs */0, (function (matchingTabResult, param) {
                  var comparisonResult = PromisedValue$SmartcutsMacros.compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsTabRef, param.contextGlobal.tabRef, promisedTabRef);
                  if (matchingTabResult === 1) {
                    return /* MatchesAtLeastOneTab */1;
                  }
                  if (matchingTabResult === 0) {
                    switch (comparisonResult) {
                      case /* ResolvedValuesAreEqual */0 :
                          break;
                      case /* ResolvedValuesAreNotEqual */1 :
                          return /* DoesNotMatchAnyTabs */0;
                      case /* UnableToDetermineEqualityBecauseOneIsNotResolved */2 :
                          return /* UnableToDeterminIfDoesNotMatchAnyTabsBecauseSomeTabsStillPending */2;
                      
                    }
                  }
                  if (comparisonResult !== 0) {
                    if (matchingTabResult >= 3) {
                      return /* UnableToDetermineIfDoesNotMatchAnyTabsBecauseTargetTabIsStillPending */3;
                    } else {
                      return /* UnableToDeterminIfDoesNotMatchAnyTabsBecauseSomeTabsStillPending */2;
                    }
                  } else {
                    return /* MatchesAtLeastOneTab */1;
                  }
                }));
  } else {
    return /* UnableToDetermineIfDoesNotMatchAnyTabsBecauseTargetTabIsStillPending */3;
  }
}

function prependCommandsToReverseCommandLogAccountingForTabId(commandsWithContextGlobal, _insertAfterOpt, _commandLogReversed) {
  while(true) {
    var insertAfterOpt = _insertAfterOpt;
    var commandLogReversed = _commandLogReversed;
    var insertAfter = insertAfterOpt !== undefined ? insertAfterOpt : /* [] */0;
    var match = Belt_List.get(commandsWithContextGlobal, 0);
    if (match === undefined) {
      return commandLogReversed;
    }
    var tmp = match.command;
    if (typeof tmp !== "number" && tmp.TAG === /* FocusTabCommand */5) {
      return List.concat({
                  hd: insertAfter,
                  tl: {
                    hd: List.rev(commandsWithContextGlobal),
                    tl: {
                      hd: commandLogReversed,
                      tl: /* [] */0
                    }
                  }
                });
    }
    var promisedTabRef = match.contextGlobal.tabRef;
    var match$1 = checkIfPromisedTabRefMatchesExistingTabInCommandLog(promisedTabRef, commandLogReversed);
    if (match$1 !== 1) {
      return List.concat({
                  hd: insertAfter,
                  tl: {
                    hd: List.rev(commandsWithContextGlobal),
                    tl: {
                      hd: commandLogReversed,
                      tl: /* [] */0
                    }
                  }
                });
    }
    if (!commandLogReversed) {
      return List.append(insertAfter, List.rev(commandsWithContextGlobal));
    }
    var currCommandWithContext = commandLogReversed.hd;
    var comparisonResult = PromisedValue$SmartcutsMacros.compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsTabRef, currCommandWithContext.contextGlobal.tabRef, promisedTabRef);
    if (comparisonResult !== 1) {
      return List.concat({
                  hd: insertAfter,
                  tl: {
                    hd: List.rev(commandsWithContextGlobal),
                    tl: {
                      hd: commandLogReversed,
                      tl: /* [] */0
                    }
                  }
                });
    }
    _commandLogReversed = commandLogReversed.tl;
    _insertAfterOpt = List.append(insertAfter, {
          hd: currCommandWithContext,
          tl: /* [] */0
        });
    continue ;
  };
}

function appendCommandsTakingIntoAccountTabs(commandsWithContextGlobal, commandLog) {
  return List.rev(prependCommandsToReverseCommandLogAccountingForTabId(commandsWithContextGlobal, undefined, List.rev(commandLog)));
}

var GlobalForRecording = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  insertAfterId: insertAfterId,
  extractOrigins: extractOrigins,
  toPrintable: toPrintable,
  toPrintableCommands: toPrintableCommands,
  getFirstURL: getFirstURL,
  checkIfPromisedTabRefMatchesExistingTabInCommandLog: checkIfPromisedTabRefMatchesExistingTabInCommandLog,
  appendCommandsTakingIntoAccountTabs: appendCommandsTakingIntoAccountTabs
};

function t_encode$3(v) {
  return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.t_encode, v);
}

function t_decode$3(v) {
  return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.t_decode, v);
}

function calcSize(unit, commandLog) {
  return Belt_List.reduce(commandLog, 0, (function (size, cmd) {
                var func = Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.calcSize;
                return size + Curry._2(func, unit, cmd) | 0;
              }));
}

function minify(commandLog) {
  return List.map(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.minify, commandLog);
}

function toGraphql(commandLog) {
  return $$Array.mapi((function (i, commandWithContext) {
                return Caml_option.some(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.toGraphql(i, commandWithContext));
              }), $$Array.of_list(commandLog));
}

function toPrintable$1(commandLog) {
  return $$Array.of_list(List.map(Command$SmartcutsMacros.CommandWithContextGlobalForAuthoring.t_encode, commandLog));
}

function toPrintableCommands$1(commandLog) {
  return $$Array.of_list(List.map((function (param) {
                    return Command$SmartcutsMacros.authoringCommand_encode(param.command);
                  }), commandLog));
}

var GlobalForAuthoring = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  calcSize: calcSize,
  minify: minify,
  toGraphql: toGraphql,
  toPrintable: toPrintable$1,
  toPrintableCommands: toPrintableCommands$1
};

function t_encode$4(v) {
  return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.t_encode, v);
}

function t_decode$4(v) {
  return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.t_decode, v);
}

function toPrintable$2(commandLog) {
  return $$Array.of_list(List.map((function (param) {
                    return Command$SmartcutsMacros.playbackCommand_encode(param.command);
                  }), commandLog));
}

function calcSize$1(unit, commandLog) {
  return Belt_List.reduce(commandLog, 0, (function (size, cmd) {
                return size + Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.calcSize(unit, cmd) | 0;
              }));
}

function minify$1(commandLog) {
  return List.map(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.minify, commandLog);
}

function rehydrate(commandLog) {
  return Promise.all($$Array.of_list(List.map(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.rehydrate, commandLog))).then(function (arr) {
              return Promise.resolve($$Array.to_list(arr));
            });
}

function toGraphql$1(commandLog) {
  return $$Array.mapi((function (i, commandWithContext) {
                return Caml_option.some(Command$SmartcutsMacros.CommandWithContextGlobalForPlayback.toGraphql(i, commandWithContext));
              }), $$Array.of_list(commandLog));
}

function doesRequireGoogleOAuth(commandLog) {
  return Belt_List.some(commandLog, (function (param) {
                return GoogleSheetHelpers$SmartcutsMacros.isGoogleSheetUrl(param.contextGlobal.url);
              }));
}

function updateNextOpenedLinkCommandWithPlaybackUrl(tabId, playbackUrl, commandLog) {
  return ListUtils$SmartcutsMacros.updateFirstMatch((function (param) {
                var command = param.command;
                if (typeof command === "number") {
                  return false;
                }
                if (command.TAG !== /* OpenedLinkCommand */7) {
                  return false;
                }
                var playbackTabId = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.getPlaybackTabId(command._0.tabRef);
                if (playbackTabId !== undefined) {
                  return Caml_obj.caml_equal(Caml_option.valFromOption(playbackTabId), tabId);
                } else {
                  return false;
                }
              }), (function (commandWithContext) {
                var contextGlobal = commandWithContext.contextGlobal;
                var command = commandWithContext.command;
                if (typeof command === "number") {
                  return commandWithContext;
                }
                if (command.TAG !== /* OpenedLinkCommand */7) {
                  return commandWithContext;
                }
                var cmdVal = command._0;
                return {
                        id: commandWithContext.id,
                        command: {
                          TAG: /* OpenedLinkCommand */7,
                          _0: {
                            tabRef: cmdVal.tabRef,
                            windowRef: cmdVal.windowRef,
                            url: playbackUrl,
                            title: cmdVal.title,
                            maybeOpenerTab: cmdVal.maybeOpenerTab,
                            viaHistoryApi: cmdVal.viaHistoryApi
                          }
                        },
                        contextGlobal: {
                          windowRef: contextGlobal.windowRef,
                          tabRef: contextGlobal.tabRef,
                          url: playbackUrl,
                          focusStatus: contextGlobal.focusStatus,
                          title: contextGlobal.title,
                          frame: contextGlobal.frame,
                          windowGeometry: contextGlobal.windowGeometry,
                          targetBoundingRect: contextGlobal.targetBoundingRect,
                          timestamp: contextGlobal.timestamp,
                          htmlSnapshot: contextGlobal.htmlSnapshot,
                          screenshot: contextGlobal.screenshot,
                          croppedScreenshot: contextGlobal.croppedScreenshot,
                          preconditions: contextGlobal.preconditions,
                          maybeLogoutLocator: contextGlobal.maybeLogoutLocator
                        }
                      };
              }), commandLog);
}

function doesNotKnowAllUrlsAheadOfTime(commandLog) {
  return Belt_List.some(commandLog, (function (param) {
                var command = param.command;
                if (Command$SmartcutsMacros.ForPlayback.isOpenedLinkCommand(command)) {
                  return true;
                } else {
                  return Command$SmartcutsMacros.ForPlayback.isLoopCommand(command);
                }
              }));
}

var GlobalForPlayback = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  toPrintable: toPrintable$2,
  calcSize: calcSize$1,
  minify: minify$1,
  rehydrate: rehydrate,
  toGraphql: toGraphql$1,
  doesRequireGoogleOAuth: doesRequireGoogleOAuth,
  updateNextOpenedLinkCommandWithPlaybackUrl: updateNextOpenedLinkCommandWithPlaybackUrl,
  doesNotKnowAllUrlsAheadOfTime: doesNotKnowAllUrlsAheadOfTime
};

function t_encode$5(v) {
  return Decco.listToJson(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.t_encode, v);
}

function t_decode$5(v) {
  return Decco.listFromJson(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.t_decode, v);
}

function fromGlobalForRecording(globalForRecording) {
  return List.map(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.fromCommandWithContextGlobalForRecording, globalForRecording);
}

function calcSize$2(unit, commandLog) {
  return Belt_List.reduce(commandLog, 0, (function (size, cmd) {
                return size + Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.calcSize(unit, cmd) | 0;
              }));
}

function minify$2(commandLog) {
  return List.map(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.minify, commandLog);
}

function toGraphql$2(commandLog) {
  return $$Array.mapi((function (i, commandWithContext) {
                return Caml_option.some(Command$SmartcutsMacros.CommandWithContextGlobalForRecordingResolved.toGraphql(i, commandWithContext));
              }), $$Array.of_list(commandLog));
}

var GlobalForRecordingResolved = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  fromGlobalForRecording: fromGlobalForRecording,
  calcSize: calcSize$2,
  minify: minify$2,
  toGraphql: toGraphql$2
};

exports.local_encode = local_encode;
exports.local_decode = local_decode;
exports.GlobalForGeneric = GlobalForGeneric;
exports.GlobalForRecording = GlobalForRecording;
exports.GlobalForAuthoring = GlobalForAuthoring;
exports.GlobalForPlayback = GlobalForPlayback;
exports.GlobalForRecordingResolved = GlobalForRecordingResolved;
/* Util-SmartcutsMacros Not a pure module */
